import { createSlice } from "@reduxjs/toolkit";

import { SIDEBARS, STRIPE_SUBSCRIPTION_INTERVALS } from "../constants";
import { clearStore } from "actions/initialization";

export const initialState = {
  sidebars: {
    [SIDEBARS.left]: false,
    [SIDEBARS.right]: false,
  },
  planToggle: STRIPE_SUBSCRIPTION_INTERVALS.month,
};

const systemSlice = createSlice({
  name: "system",
  initialState,
  reducers: {
    toggleSidebar(state, action) {
      const { sidebar = SIDEBARS.left, open } = action.payload;
      state.sidebars = {
        ...initialState.sidebars,
        [sidebar]: open,
      };
    },
    togglePlan(state, action) {
      const { value } = action.payload;
      state.planToggle = value;
    },
  },
  extraReducers: (builder) => builder.addCase(clearStore, () => initialState),
});

export const actions = systemSlice.actions;

export default systemSlice.reducer;
